import React, { lazy } from "react";
import { Route } from "react-router-dom";
import Verify from "../../pages/auth/Verify";
import ProtectedAuthRoute from "../PrivateAuthRoute";

// Lazy load auth pages
const Login = lazy(() => import("../../pages/auth/Login"));
const Signup = lazy(() => import("../../pages/auth/Signup"));
const ForgetPassword = lazy(() => import("../../pages/auth/ForgetPassword"));
const ResetPass = lazy(() => import("../../pages/auth/ResetPass"));

const authRoutes = [
  <Route
    path="/"
    element={
      <ProtectedAuthRoute>
        <Login />
      </ProtectedAuthRoute>
    }
    key="login"
  />,
  <Route
    path="/signup"
    element={
      <ProtectedAuthRoute>
        <Signup />
      </ProtectedAuthRoute>
    }
    key="signup"
  />,
  <Route
    path="/forget"
    element={
      <ProtectedAuthRoute>
        <ForgetPassword />
      </ProtectedAuthRoute>
    }
    key="forget"
  />,
  <Route
    path="/reset-password/:token"
    element={
      <ProtectedAuthRoute>
        <ResetPass />
      </ProtectedAuthRoute>
    }
    key="reset"
  />,
  <Route
    path="/verify"
    element={
      <ProtectedAuthRoute>
        <Verify />
      </ProtectedAuthRoute>
    }
    key="verify"
  />,
];

export default authRoutes;
